module.exports = __webpack_public_path__ + "img/ideation-04-keyfeature-sample-03.005cb6ac.jpg";